<template>
  <form class="reset-password" @submit.prevent="resetPassword">
    <div v-if="isLoading">
      <SfeLoader />
    </div>
    <div v-else>
      <h1 class="fs-24 text-muted fw-500 mb-1 reset-password__primary-heading">
        Hey {{ `${determineAdminName}` }}!
      </h1>
      <p class="fs-15 text-light-grey-1 mb-3 font-weight-normal">
        Let’s create your new password
      </p>

      <!-- Password Input fields begins -->

      <div class="form-group mb-3">
        <SfeLabel required class="mb-1">
          Password
          <small class="text-muted font-italic mx-1">( Min 8 chars, uppercase, lowercase and symbol)</small>
        </SfeLabel>
        <PasswordInput v-model="form.password" />
        <ShrInputError :error="errors.password" />
      </div>
      <div class="form-group mb-4">
        <SfeLabel
          class="mb-1"
        >
          Confirm Password
        </SfeLabel>
        <PasswordInput
          autocomplete="off"
          v-model="form.password_confirmation"
        />
        <ShrInputError :error="errors.password_confirmation" />
      </div>

      <!-- Password Input fields end -->

      <!-- Button container -->

      <div class="button-container mb-3">
        <SfeButton
          size="lg"
          :disabled="buttonIsDisabled"
          type="submit"
          class="btn fs-18 fw-400 text-center btn-primary-light-blue border-radius-8 py-3 d-flex align-items-center justify-content-center w-100"
        >
          Create Password
          <SfeLoader
            v-if="isLoading"
            class="ml-1"
            size="sm"
            color="white"
          />
        </SfeButton>
      </div>
    </div>

    <!-- Button container -->
  </form>
</template>

<script>
import CandidateModel from "../../../models/CandidateModel";
import AdminModel from "../../../models/AdminModel";
import UserModel from "../../../models/UserModel";
import PasswordInput from "../../../components/auth/PasswordInput";
export default {
  components: { PasswordInput },
  data() {
    return {
      isLoading: false,
      form: {
        password: "",
        password_confirmation: "",
      },
      errors: {},
      user: {},
    };
  },
  mixins: [CandidateModel, UserModel, AdminModel],
  mounted() {
    this.fetchUserDetailsFromEmailToken();
  },
  methods: {
    resetPassword() {
      this.form.token = this.$route.params.token;
      this.isLoading = true;
      const userType = this.$route.params.userType;
      this[userType === "candidate" ? "CandidateModel" : "AdminModel"]
        .resetPassword(this.form)
        .then((r) => {
          this.isLoading = false;
          this.$emit("reset-password:successful");
        })
        .catch((e) => {
          this.errors = e?.errors || {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchUserDetailsFromEmailToken() {
      const token = this.$route.params.token;
      // the database expect the userType to be uppercase
      const userType = this.$route.params.userType.toUpperCase();
      this.isLoading = true;
      const params = {
        token,
        user_type: userType,
      };
      return this.UserModel.fetchUserDetailsFromEmailToken(params)
        .then((response) => {
          this.isLoading = false;
          this.user = response.data;
        })
        .catch((e) => {
          this.errors = e?.errors || {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    buttonIsDisabled() {
      return Object.values(this.form).some((parameter) => !parameter);
    },
    userHasBeenFetched() {
      return Object.keys(this.user).length > 0;
    },
    determineAdminName() {
      const userType = this.$route.params.userType;

      if (userType === "admin") {
        return (
          this.user.name || `${this.user.first_name} ${this.user.last_name}`
        );
      }
      return `${this.user.first_name} ${this.user.last_name}` || this.user.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 320px) {
  .reset-password {
    padding: 20px 12px 24px 12px;
    border-radius: 4px;
    background-color: #fcfcfd;
    min-height: 100vh;
    &__primary-heading {
      margin-top: 1rem;
    }
    &__seamless-jobs-logo {
      display: inline-block;
    }
  }
}
@media screen and (min-width: 768px) {
  .reset-password {
    background-color: #ffffff;
    padding: 100px 80px;
    max-width: 50%;
    margin: 0 auto 0 auto;
    &__primary-heading {
      margin-top: 0;
    }
    &__seamless-jobs-logo {
      display: none;
    }
  }
}
</style>
